import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-scanner__title" }
const _hoisted_2 = { class: "modal-scanner__buttons-panel" }
const _hoisted_3 = { "сlass": "modal-scanner__btn" }
const _hoisted_4 = {
  key: 0,
  "сlass": "modal-scanner__btn",
  for: "inputFile",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_5 = {
  key: 1,
  "сlass": "modal-scanner__btn",
  for: "inputFile",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_6 = {
  key: 1,
  "сlass": "modal-scanner__btn"
}
const _hoisted_7 = { for: "inputCameraFile" }
const _hoisted_8 = { class: "modal-scanner" }
const _hoisted_9 = { class: "modal-scanner__content" }
const _hoisted_10 = { class: "modal-scanner__content-main" }
const _hoisted_11 = { class: "modal-scanner__result" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "modal-scanner__right" }
const _hoisted_14 = {
  key: 0,
  class: "modal-scanner__buttons-actions"
}
const _hoisted_15 = { class: "modal-scanner__fields" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 1,
  class: "modal-scanner__fields-ru"
}
const _hoisted_18 = {
  key: 2,
  class: "modal-scanner__fields-en"
}
const _hoisted_19 = { class: "modal-scanner__errors" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cropper = _resolveComponent("Cropper")!
  const _component_video_recorded = _resolveComponent("video-recorded")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onOnsuccess: _ctx.saveWords }, {
    title: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.Ti18N('scanner.loadInnerList')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "file",
          id: "inputFile",
          hidden: "",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadFile && _ctx.loadFile(...args))),
          ref: "file1"
        }, null, 544),
        _createElementVNode("button", _hoisted_3, [
          (_ctx.listWords.ru.length > 0 !== _ctx.listWords.en.length > 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, _toDisplayString(_ctx.Ti18N('scanner.loadSecondFile')), 1))
            : (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString(_ctx.Ti18N('scanner.loadFile')), 1))
        ]),
        (!_ctx.isMobilePhone)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "сlass": "modal-scanner__btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cameraOn && _ctx.cameraOn(...args)))
            }, _toDisplayString(_ctx.Ti18N('scanner.loadWithWeb')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "file",
          accept: "image/*",
          id: "inputCameraFile",
          capture: "",
          hidden: "",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadFile && _ctx.loadFile(...args)))
        }, null, 32),
        (_ctx.isMobilePhone)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.Ti18N('scanner.loadWithCamera')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (!_ctx.isEdit && _ctx.fileSrc != null)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "modal-scanner__img",
                    src: _ctx.fileSrc
                  }, null, 8, _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock(_component_Cropper, {
                    key: 1,
                    onKeyup: _withKeys(_ctx.editImage, ["enter"]),
                    class: "modal-scanner__img",
                    ref: "cropperElement",
                    src: _ctx.fileSrc,
                    onChange: _ctx.changeCrooperElement
                  }, null, 8, ["onKeyup", "src", "onChange"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.fileSrc != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.isEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "profile__run",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.editImage && _ctx.editImage(...args)))
                          }, _toDisplayString(_ctx.Ti18N('scanner.ready')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "profile__run",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteImage && _ctx.deleteImage(...args)))
                      }, _toDisplayString(_ctx.Ti18N('scanner.removeImg')), 1),
                      (!_ctx.isEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "profile__run",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendImage('eng')))
                          }, _toDisplayString(_ctx.Ti18N('scanner.en')), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.isEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "profile__run",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendImage('rus')))
                          }, _toDisplayString(_ctx.Ti18N('scanner.rus')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.progress < 1)
                    ? (_openBlock(), _createElementBlock("progress", {
                        key: 0,
                        value: _ctx.progress,
                        max: "1"
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  (_ctx.listWords.ru.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.Ti18N('scanner.ruSymbols')), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listWords.ru) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.listWords.ru]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listWords.en.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.Ti18N('scanner.enSymbols')), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listWords.en) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.listWords.en]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.isOpenVideo && _ctx.errorsList.length == 0)
              ? (_openBlock(), _createBlock(_component_video_recorded, {
                  key: 0,
                  isOpenVideo: _ctx.isOpenVideo,
                  onSetImageURL: _ctx.setImageURL,
                  onSetErrors: _ctx.setErrors
                }, null, 8, ["isOpenVideo", "onSetImageURL", "onSetErrors"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsList, (error) => {
              return (_openBlock(), _createElementBlock("p", {
                key: error.msg
              }, _toDisplayString(error.msg), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    acceptButton: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Ti18N('account.wordsTable.panel.save')), 1)
    ]),
    _: 1
  }, 8, ["onOnsuccess"]))
}